export default __webpack_public_path__ + "static/media/ENGLISH_SPELLING.bb800604.svg";